<template>
    <div class="modal fade show" style="display: block" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{finalizer.TargetSystem.Name}}</h5>
                <button type="button" class="close" data-dismiss="modal"  :aria-label="translate('close')" @click="$emit('onclose')">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row" v-if="finalizer.RemOperation">
                    <div class="col">
                        <small class="text-right text-muted float-right" v-if="finalizer.RemOperation.LastUpdateTime">{{translate('evidences.lastUpdate')}}: {{finalizer.RemOperation.LastUpdateTime | datetime}}</small>
                        <h5>{{translate('evidences.evidences')}}</h5>
                        <div class="form-control" style="height:400px; overflow-y:scroll; padding:0">
                            <evidence-list :evidences="finalizer.RemOperation.Evidences"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer footer-button-container">
                <button type="button" class="btn btn-outline-secondary" @click="$emit('onclose')">{{translate('close')}}</button>
                <button type="submit" v-if="finalizer.RemOperation.CanRefreshEvidences" class="btn btn-success" @click="$emit('refresh', finalizer)">{{translate('evidences.updateEvidences')}}</button>
            </div>
            </div>
        </div>
    </div>
</template>
<script>
//import evidenceList from 'EvidenceList.vue'
import evidenceList from './EvidenceList.vue';

export default {
    props: {
        finalizer: Object
    },
    components: {
        evidenceList
    }
}
</script>